class MatchModeManager {

	constructor(){
		this.currentMode = MatchModeManager.modes.SEARCH;
		this.currentBattleMode = MatchModeManager.battleModes.NO_MATCH;
	}

	changeBattleMode(mode){
		if(!this.battleContainer)
		{
			this.battleContainer = $('#tab-pane-battle');
		}
		if(this.currentBattleMode == mode)
		{
			return; //Already good
		}
		this.currentBattleMode = mode;
		for(let i in MatchModeManager.battleModes){
            const otherMode = MatchModeManager.battleModes[i];
			if(otherMode != mode)
            {
                this.battleContainer.removeClass(otherMode);
            }
        }
        this.battleContainer.addClass(mode);
	}

	changeViewMode(mode){
		if(!this.container)
		{
			this.container = $('#tab-pane-matchmaking');
		}
		if(this.currentMode == mode)
		{
			return; //Already good
		}
		this.currentMode = mode;
		$.each(MatchModeManager.modes, (i, otherMode) =>{
            if(otherMode != mode)
            {
                this.container.removeClass(otherMode);
            }
        });
        this.container.addClass(mode);
	}

	getCurrentViewMode(){
		return this.currentMode;
	}

	getCurrentBattleMode(){
		return this.currentBattleMode;
	}

	viewModeIs(viewMode){
		return this.getCurrentViewMode() === viewMode;
	}

	battleModeIs(viewMode){
		return this.getCurrentBattleMode() === viewMode;
	}
}

MatchModeManager.modes = {
	SELECT_OPTIONS: 'select_options',
	SEARCH: 'search_mode',
	ACTIVITY_MODE: 'activity_mode'
};
MatchModeManager.battleModes = {
	NO_MATCH: 'no_match',
	MATCH_SINGLES: 'match_singles',
	MATCH_DOUBLES: 'match_doubles'
};

var matchModeManager = new MatchModeManager();
export {MatchModeManager, matchModeManager}
